// @flow\
import React, { Component } from 'react'
import { connect, Provider } from 'react-redux'
import { IntlProvider } from 'react-intl'
import Router from 'routes/Router'
import * as localeData from 'i18n/'
// $FlowFixMe
import '../style.scss'

type Props = {
  history: Object,
  store: Object,
  locale: string,
}

class AppContainer extends Component {
  props: Props

  render (): React.Element<any> {
    const { history, store, locale } = this.props
    const messages = {...localeData, ...localeData['en']}
    const intlData = {
      locale,
      messages: messages[locale],
    }

    return (
      <Provider store={store}>
        <IntlProvider {...intlData}>
          <Router store={store} history={history} key={locale} />
        </IntlProvider>
      </Provider>
    )
  }
}

const mapStateToProps = ({locale}: Object): Object => ({
  locale,
})

export default connect(mapStateToProps)(AppContainer)
